import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '../../../common/styles/style-constants';

const Committed = ({ color }) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g fill={color} fillRule="nonzero">
      <path d="M16.743 8.114a1.901 1.901 0 0 0-1.9 1.9.69.69 0 0 0 1.38 0 .521.521 0 0 1 1.04 0 .69.69 0 1 0 1.38 0 1.901 1.901 0 0 0-1.9-1.9zM9.214 10.013a1.9 1.9 0 0 0-3.799 0 .69.69 0 0 0 1.38 0 .52.52 0 1 1 1.04 0 .69.69 0 0 0 1.379 0zM15.092 11.449H8.903a.69.69 0 0 0-.689.689 3.784 3.784 0 1 0 7.568 0 .69.69 0 0 0-.69-.69zM12 14.545a2.413 2.413 0 0 1-1.701-.707 3.302 3.302 0 0 1 3.403 0 2.413 2.413 0 0 1-1.702.707z" />
      <path d="M12 .281C5.538.281.281 5.538.281 12S5.538 23.719 12 23.719 23.719 18.462 23.719 12 18.462.281 12 .281zm0 22.06C6.298 22.34 1.66 17.7 1.66 12 1.66 6.298 6.298 1.66 12 1.66S22.34 6.298 22.34 12 17.702 22.34 12 22.34z" />
    </g>
  </svg>
);

Committed.defaultProps = {
  color: colors.blue,
};

Committed.propTypes = {
  color: PropTypes.string,
};

export default Committed;
